"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="256629" id="hero-banner" className="w-full bg-primary py-20 md:py-32 flex flex-col items-center justify-center relative overflow-hidden">
      {}
      
      <div ref={ref} className={`container px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground uppercase tracking-widest font-default">
          ESTRUCTURAS
        </h1>
        
        {}
        <div className="w-24 md:w-32 h-1.5 bg-accent mt-6 md:mt-8 rounded-md shadow-sm"></div>
      </div>
    </section>;
}